import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import GlobalBar from "./shell/GlobalBar";
import { currentSection } from "./shell/section";

const section = currentSection();
const Section = lazy(() => (section === "hub" ? import("./consulting/Entry") : import("./fire/Entry")));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalBar section={section} />
    <Suspense fallback={null}>
      <Section />
    </Suspense>
  </React.StrictMode>,
);
